'use strict';

function addKeywordToPostData(keywords, postData) {
    // Find the keyword object with isMain: true
    var mainKeywordObj = (keywords || []).find(function(kw) { return kw.isMain; });
    // Use the 'name' property if found, otherwise empty string
    var mainKeyword = mainKeywordObj ? mainKeywordObj.name : '';
    if(mainKeyword) {
        postData.vars = postData.vars || {};
        postData.vars.keyword = mainKeyword;
    }
}

function addKeywordsToPostData(keywords, postData) {
    postData.vars = postData.vars || {};
    postData.vars.keywords = keywords.map(function(kw) {
        return kw.name;
    })
}

// Store for shortcode mappings
var shortcodeMappings = {};

function replaceShortcodesWithPlaceholders(content) {
    if (!content) return '';
    
    // Reset mappings for new content
    shortcodeMappings = {};
    var counter = 0;
    
    // Function to create unique identifier
    function createPlaceholder(type) {
        return '<shortcode id="shortcode_' + type + '_' + (counter++) + '">';
    }
    
    var processedContent = content
        // Remove summary blocks entirely
        .replace(/<summaryblock>[\s\S]*?<\/summaryblock>/g, '')
        // Handle caption blocks
        .replace(/<captionblock[^>]*>[\s\S]*?<\/captionblock>/g, function(match) {
            var placeholder = createPlaceholder('caption');
            shortcodeMappings[placeholder] = match;
            return placeholder;
        })
        // Handle gallery blocks
        .replace(/<galleryblock[^>]*>[\s\S]*?<\/galleryblock>/g, function(match) {
            var placeholder = createPlaceholder('gallery');
            shortcodeMappings[placeholder] = match;
            return placeholder;
        })
        // Handle embed blocks
        .replace(/<embedblock[^>]*>[\s\S]*?<\/embedblock>/g, function(match) {
            var placeholder = createPlaceholder('embed');
            shortcodeMappings[placeholder] = match;
            return placeholder;
        })
        // Handle video shortcodes
        .replace(/\[video[^\]]*\]/g, function(match) {
            var placeholder = createPlaceholder('video');
            shortcodeMappings[placeholder] = match;
            return placeholder;
        })
        // Handle poll shortcodes
        .replace(/\[poll[^\]]*\][\s\S]*?\[\/poll\]/g, function(match) {
            var placeholder = createPlaceholder('poll');
            shortcodeMappings[placeholder] = match;
            return placeholder;
        })
        // Handle rating shortcodes
        .replace(/\[rating[^\]]*\][\s\S]*?\[\/rating\]/g, function(match) {
            var placeholder = createPlaceholder('rating');
            shortcodeMappings[placeholder] = match;
            return placeholder;
        })
        // Handle quote shortcodes
        .replace(/\[quote[^\]]*\]([\s\S]*?)\[\/quote\]/g, function(match) {
            var placeholder = createPlaceholder('quote');
            shortcodeMappings[placeholder] = match;
            return placeholder;
        })
        // Handle readalso shortcodes
        .replace(/\[readalso[^\]]*\][\s\S]*?\[\/readalso\]/g, function(match) {
            var placeholder = createPlaceholder('readalso');
            shortcodeMappings[placeholder] = match;
            return placeholder;
        })
        // Handle liveblog shortcodes
        .replace(/\[liveblog[^\]]*\][\s\S]*?\[\/liveblog\]/g, function(match) {
            var placeholder = createPlaceholder('liveblog');
            shortcodeMappings[placeholder] = match;
            return placeholder;
        });
    return processedContent;
}

function restoreShortcodes(content) {
    if (!content) return content;
    
    var restoredContent = content;
    // Restore all shortcodes in reverse order to handle nested cases
    Object.keys(shortcodeMappings).reverse().forEach(function(placeholder) {
        restoredContent = restoredContent.replace(placeholder, shortcodeMappings[placeholder]);
    });
    return restoredContent;
}

module.exports = {
    addKeywordToPostData: addKeywordToPostData,
    addKeywordsToPostData: addKeywordsToPostData,
    replaceShortcodesWithPlaceholders: replaceShortcodesWithPlaceholders,
    restoreShortcodes: restoreShortcodes
};




//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/AIModal/helpersFunction.js
// module id = 157
// module chunks = 0